<template>
    <div class="clearfix">
      <span class="floatleft"><img style="height:34px;margin-top:10px" src="../../assets/img/logo.png"/></span>
      <ul class="floatleft menu">
        <router-link to="/home" tag="li" active-class="menuActive"><a>产品介绍</a></router-link>
        <router-link to="/project" tag="li" active-class="menuActive"><a>解决方案</a></router-link>
        <router-link to="/scene" tag="li" active-class="menuActive"><a>应用场景</a></router-link>
        <router-link to="/video" tag="li" active-class="menuActive"><a>影片教学</a></router-link>
        <router-link to="/dataDownload" tag="li" active-class="menuActive"><a>知识资料</a></router-link>
        <router-link to="/qa" tag="li" active-class="menuActive"><a>FAQ</a></router-link>
      </ul>
      <div class="floatleft" style="line-height: 45px;">
        <el-switch
          v-model="isCN"
          active-color="#13ce66"
          inactive-color="#dcdfe6"
          @change="change"
          active-text="简体"
          inactive-text="繁体">
        </el-switch>
      </div>
    </div>
</template>
<script>
  export default {
    name: 'OmpLink',
    data() {
      return {
        active: 1,
        isCN: true
      }
    },
    methods: {
      change(){
        window.location.href="https://escloud.digiwincloud.com/omp-web/#/home"
      }
    }
  }
</script>
<style>
.el-switch__label.is-active {
    color: #ffffff !important;
}
</style>



// WEBPACK FOOTER //
// src/components/common/OmpLink.vue